<template>
    <div class="top-nav">
        <div class="top-nav__links">
            <router-link :to="{ name: button.path }" v-for="(button, index) in buttons" v-bind:key="index" class="top-nav__link text-center text-uppercase">
                {{ button.name }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainNavMenu",
    props:{
        buttons: {
            type: Array,
            required: true
        },
    }
}
</script>

<style scoped>
    .top-nav {
        width: 100%;
    }

    .top-nav__links {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 6px;
        flex-wrap: wrap;
    }

    .top-nav__link {
        display: inline-flex;
        align-items: center;
        min-height: 24px;
        padding: 4px 9px;
        border-radius: 8px;
        color: #173b5d;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0;
        transition: background-color 0.2s ease, color 0.2s ease;
    }

    .top-nav__link:hover,
    .router-link-active {
        color: #0f2641;
        background: #e9f0f8;
    }

    @media (max-width: 767.98px) {
        .top-nav {
            overflow-x: auto;
            overflow-y: hidden;
        }

        .top-nav__links {
            width: max-content;
            min-width: 100%;
            justify-content: flex-start;
            flex-wrap: nowrap;
        }

        .top-nav__link {
            flex: 0 0 auto;
            min-height: 32px;
            padding: 6px 10px;
            font-size: 0.7rem;
            white-space: nowrap;
        }
    }
</style>
